import moment from 'moment'

export default {
    data() {
        return {
            showErrorMessage(message, duration, position) {
                position = position || "top-right";
                duration = duration || 4000;
                this.$toast.show(message, {
                    type: "error",
                    icon: {
                        name: "bi bi-exclamation-triangle",
                    },
                    duration: duration,
                    position: position,
                });
            },
            showSuccessMessage(message, duration, position) {
                duration = duration || 4000;
                position = position || "top-right";
                this.$toast.show(message, {
                    type: "success",
                    icon: {
                        name: "bi bi-check",
                    },
                    duration: duration,
                    position: position,
                });
            },
            getLocalDateTime(date) {
                if (date == null) {
                    return '';
                }
                return moment(date).local().format('Do MMM YY, h:mm a');
            },
            getLocalDate(date) {
                if (date == null) {
                    return '';
                }
                return moment.utc(date).local().format('Do MMMM YYYY');
            },
            initializeTooltip() {
                setTimeout(() => {
                    const tooltipElements = document.querySelectorAll(".tooltip");
                    tooltipElements.forEach((element) => {
                        element.classList.remove("show");
                        element.classList.add("hide");
                    });

                    var tooltipTargetElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
                    for (var i = 0; i < tooltipTargetElements.length; i++) {
                        var tooltipTargetElement = tooltipTargetElements.item(i);
                        new window.bootstrap.Tooltip(tooltipTargetElement);
                    }
                }, 500);
            },
            capitalizeFirstLetter(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            formattedAmount(amount) {
                return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              }
        }
    }
}